import React from "react";

function ProgressInner({ title, value }) {
  return (
    <div className="progress_inner">
      <span>
        <span className="label">{title}</span>
        <span className="number">{value}%</span>
      </span>
      <div className="background">
        <div className="bar">
          <div className="bar_in" style={{ width: value + "%" }}></div>
        </div>
      </div>
    </div>
  );
}

export default ProgressInner;
